export default __webpack_public_path__ + "static/taboola-b5df27ddd8a149d5415f6aabae344fbf.svg";